"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactStringReplace = _interopRequireDefault(require("react-string-replace"));
var _functions = require("../../util/functions");
var _i18n = _interopRequireDefault(require("../../util/i18n.js"));
require("./HoldingsTable.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Lookup for converting Lipper geo focus to approved categories
const GEO_FOCUS_LOOKUP = {
  'United States of America': 'Domestic Equity',
  'Global Ex US': 'International Equity',
  'Global Emerging Markets': 'EM Equity',
  'Global': 'Global',
  'Japan': 'International Equity',
  'EuroZone': 'International Equity'
};
const EQUITY = 'Equity';
class HoldingsTable extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      i18n: this.props.translationDictionary ? this.props.translationDictionary : _i18n.default
    };
  }
  // Render all rows for a given asset class. The holdingsZipped are assumed to be filtered for the asset class
  renderAssetClassRows(assetClass, holdingsZipped) {
    const {
      weightDecimals
    } = this.props;

    // If Equity then set up the geoFocus totals, in order to sub-sort the array on geofocus
    const geoFocusWeights = {};
    if (assetClass === EQUITY) {
      const geoFocuses = (0, _functions.onlyUniqueFromArray)(holdingsZipped.map(holding => {
        return holding.geoFocus;
      }));
      geoFocuses.forEach(geoFocus => {
        // Sum up the weights for this geoFocus
        const geoFocusWeight = holdingsZipped.reduce(function (a, b) {
          if (b.geoFocus === geoFocus) {
            return a + b.weight;
          } else {
            return a;
          }
        }, 0);

        // Store the weight in a dict so we can use to sort
        geoFocusWeights[geoFocus] = geoFocusWeight;
      });
    }

    // Sort those results by total in geoFocus first (if equity), and then by weighting
    const assetClassRows = holdingsZipped.sort((a, b) => a.geoFocus === b.geoFocus || assetClass !== EQUITY ? a.weight < b.weight || a.weight === b.weight && a.ticker > b.ticker ? 1 : -1 : geoFocusWeights[a.geoFocus] < geoFocusWeights[b.geoFocus] ? 1 : -1);

    // Get total weight for this asset class
    const totalWeightForAssetClass = assetClassRows.reduce(function (a, b) {
      return a + b.weight;
    }, 0);

    // Create var to store which geoFocus we're on (already sorted by that)
    let currentGeoFocus;

    // Get the output rows include headers for asset class
    const assetClassOutput = assetClassRows.map((holding, index) => {
      let firstRow, equityHeaderRow, holdingRow;

      // If the first row then add the asset class heading
      if (index === 0) {
        firstRow = /*#__PURE__*/_react.default.createElement("tr", {
          className: (0, _classnames.default)(index === 0 ? 'whiteline' : 'greyline'),
          key: "".concat(holding.ticker).concat(assetClass, "_first")
        }, /*#__PURE__*/_react.default.createElement("td", {
          className: "asset-class-header textLeft row-name ticker sticky",
          colSpan: "2"
        }, assetClass), /*#__PURE__*/_react.default.createElement("td", {
          className: (0, _classnames.default)('textRight', 'asset-class-header')
        }, (0, _functions.formatPercent)(totalWeightForAssetClass, weightDecimals)));
      }

      // Add a total row if the geoFocus has changed
      if (currentGeoFocus !== holding.geoFocus && assetClass === EQUITY) {
        // Get total weight for this geoFocus
        const totalWeightForGeoFocus = assetClassRows.reduce(function (a, b) {
          if (b.geoFocus === holding.geoFocus) {
            return a + b.weight;
          } else {
            return a;
          }
        }, 0);
        equityHeaderRow = /*#__PURE__*/_react.default.createElement("tr", {
          className: (0, _classnames.default)(index === 0 ? 'whiteline' : 'greyline'),
          key: "".concat(holding.ticker).concat(holding.geoFocus, "_first")
        }, /*#__PURE__*/_react.default.createElement("td", {
          className: "geofocus-header textLeft row-name ticker sticky",
          colSpan: "2"
        }, holding.geoFocus), /*#__PURE__*/_react.default.createElement("td", {
          className: (0, _classnames.default)('textRight', 'geofocus-header')
        }, (0, _functions.formatPercent)(totalWeightForGeoFocus, weightDecimals)));
      }
      currentGeoFocus = holding.geoFocus;

      // If the ticker is not CASH then show it as a real holding. Cash will only get the 'first row' heading
      // Crypto assets (type=CY) will not have tickers
      if (holding.ticker !== '$CASH') {
        holdingRow = /*#__PURE__*/_react.default.createElement("tr", {
          className: "greyline",
          key: holding.ticker
        }, /*#__PURE__*/_react.default.createElement("td", {
          className: "textLeft row-name ticker sticky"
        }, holding.type !== 'CY' ? holding.ticker : '-'), /*#__PURE__*/_react.default.createElement("td", {
          className: (0, _classnames.default)('textLeft')
        }, holding.name), /*#__PURE__*/_react.default.createElement("td", {
          className: (0, _classnames.default)('textRight')
        }, (0, _functions.formatPercent)(holding.weight, weightDecimals)));
      }
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, firstRow, equityHeaderRow, holdingRow);
    });

    // Save the output rows to the array along with total weight so we can sort later
    return {
      "assetClass": assetClass,
      "output": assetClassOutput,
      "totalWeight": totalWeightForAssetClass
    };
  }

  // create the rows
  renderRows() {
    const {
      data
    } = this.props;

    // Get the holdings from the portfolio data
    const holdings = data && data[0].holdings && data[0].holdings.length > 0 ? data[0].holdings[0] : null;
    if (holdings) {
      // Zip the holdings together into an array of objects
      // Set geoFocus based on mapping
      const holdingsZipped = holdings.tickers.map((ticker, index) => {
        return {
          'ticker': ticker,
          'name': holdings.names[index],
          'weight': holdings.weights[index],
          'assetClass': holdings.assetClasses[index],
          'type': holdings.types[index],
          'geoFocus': GEO_FOCUS_LOOKUP[holdings.geoFocuses[index]] ? GEO_FOCUS_LOOKUP[holdings.geoFocuses[index]] : _i18n.default.t('Other')
        };
      });

      // Get the asset classes and sort by name
      const assetClasses = (0, _functions.onlyUniqueFromArray)(data[0].holdings[0].assetClasses).sort((a, b) => a > b ? 1 : -1);
      let outputRows = [];
      assetClasses.forEach(assetClass => {
        // Save the output rows to the array along with total weight so we can sort later
        outputRows.push(this.renderAssetClassRows(assetClass, holdingsZipped.filter(holding => holding.assetClass === assetClass)));
      });

      // Sort the asset Classes by weight descending
      outputRows = outputRows.sort((a, b) => a.totalWeight < b.totalWeight ? 1 : -1);

      // Return just the HTML output
      return outputRows.map(row => {
        return row.output;
      });
    } else {
      return null;
    }
  }

  // create the header
  renderHeader() {
    const {
      i18n
    } = this.state;
    const {
      data
    } = this.props;
    const holdings = data && data[0].holdings && data[0].holdings.length > 0 ? data[0].holdings[0] : null;
    let asOfDate = "".concat(i18n.t('target-allocations'));
    if (holdings) {
      asOfDate = "".concat(asOfDate, " (").concat(i18n.t('as of'), " ").concat(new Date(holdings.date).toLocaleDateString(), ")");
    }
    return /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "textLeft ticker sticky"
    }, i18n.t('Ticker')), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "textLeft"
    }, i18n.t('Name')), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "textRight"
    }, asOfDate)));
  }
  render() {
    const {
      footnote
    } = this.props;
    let formattedFootnoteText;
    if (footnote) {
      formattedFootnoteText = (0, _reactStringReplace.default)(footnote, '<br/>', match => /*#__PURE__*/_react.default.createElement("br", {
        key: Math.random()
      }));
      formattedFootnoteText = (0, _reactStringReplace.default)(formattedFootnoteText, /<strong>(.*)<\/strong>/g, match => /*#__PURE__*/_react.default.createElement("strong", {
        key: Math.random()
      }, match));
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "holdings-table-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "table-responsive"
    }, /*#__PURE__*/_react.default.createElement("table", {
      className: 'table'
    }, this.renderHeader(), /*#__PURE__*/_react.default.createElement("tbody", null, this.renderRows()))), formattedFootnoteText ? /*#__PURE__*/_react.default.createElement("div", {
      className: "perf-footnote"
    }, formattedFootnoteText) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("br", null)));
  }
}
_defineProperty(HoldingsTable, "defaultProps", {
  data: null,
  translationDictionary: null,
  showTitle: true,
  weightDecimals: 2
});
HoldingsTable.propTypes = {
  /**
   * Fund data to be used for Performance. Should be array of funds
   */
  data: _propTypes.default.array.isRequired,
  /**
   * Translation dictionary (i18) - needed for tables, but can default to included version
   */
  translationDictionary: _propTypes.default.object,
  /**
   * Show the title or not
   */
  showTitle: _propTypes.default.bool,
  /**
   * Footnote text
   */
  footnote: _propTypes.default.string,
  /**
   * Specify how many decimal points to use for holdings weights. Defaults to 2.
   */
  weightDecimals: _propTypes.default.number
};
var _default = exports.default = HoldingsTable;